import { render, staticRenderFns } from "./FontsReplacementMatcherModal.vue?vue&type=template&id=32f4fa40&scoped=true"
import script from "./FontsReplacementMatcherModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FontsReplacementMatcherModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FontsReplacementMatcherModal.vue?vue&type=style&index=0&id=32f4fa40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f4fa40",
  null
  
)

export default component.exports